'use strict';
import { environment } from '@environments/environment';

fm1099Controller.$inject = ['$scope', '$q', '$uibModal', '$location', '$interval', 'dialogHelper', 'reportHelper', 'fm1099Service', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('fm1099Controller', fm1099Controller);

function fm1099Controller($scope, $q, $uibModal, $location, $interval, dialogHelper, reportHelper, fm1099Service, BUSY_MESSAGE) {
	const formType1099 = {
		MISC: 0,
		NEC: 1,
	};

	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.refresh1099Interval = null;
	$scope.isReportFinished = false;

	$scope.vm.busyPromise = $q.all([$scope.vm.loadForm($scope.vm)]);

	function getViewModel() {
		var model = {
			isInitialLoad: true,
			taxYears: [],
			selectedTaxYear: null,
			vendors: [],
			vendorsSelected: [],
			vendorsFiltered: [],
			print1096: null,
			vendorsCheckAll: false,
			horizontal: null,
			vertical: null,
			validationErrors: [],
			isReload: false,
			createIRS: true,
			createState: true,
			isReadyForFinalize: false,
			isFinalized: false,
			hasTotals: false,
			vendorErrors: false,
			historyInfo: null,
			formTypes: [
				{ Id: null, Description: 'All' },
				{ Id: formType1099.MISC, Description: 'MISC' },
				{ Id: formType1099.NEC, Description: 'NEC' },
			],
			selectedFormType: null,
			contact: {
				Name: null,
				Phone: null,
				PhoneExt: null,
				Email: null,
				TCC: null,
			},
			busyPromise: null,
			busyMessage: BUSY_MESSAGE.Loading,
			errors: null,
		};

		function loadForm(model) {
			return fm1099Service.getTaxYears().then(_.partial(finishLoadingForm, model));

			function finishLoadingForm(model, response) {
				model.taxYears = response.data.taxYears;

				var currentYear = new Date().getFullYear();
				if (
					_.filter(model.taxYears, function (year) {
						return year === currentYear;
					}).length > 0
				) {
					model.selectedTaxYear = currentYear;
				} else {
					model.selectedTaxYear = model.taxYears[0];
				}

				model.eventRefresh($scope.vm);
			}
		}

		function loadVendors(model) {
			return fm1099Service.getVendors(model.selectedTaxYear).then(_.partial(finishedLoadingVendors, model));

			function finishedLoadingVendors(model, response) {
				if (response) {
					model.errors = [];
					model.vendors = response.data.Vendors;
					model.isFinalized = response.data.IsFinalized;
					model.hasTotals = response.data.HasTotals;
					model.vendorErrors =
						_.filter(model.vendors, function (vendor) {
							return vendor.MissingFederalId === true || vendor.MissingTINCode === true;
						}).length > 0;

					if (response.data.FM1099ControlInfo) {
						model.contact.Name = response.data.FM1099ControlInfo.ContactName;
						model.contact.Phone = response.data.FM1099ControlInfo.ContactPhone;
						model.contact.PhoneExt = response.data.FM1099ControlInfo.ContactPhoneExt;
						model.contact.Email = response.data.FM1099ControlInfo.ContactEmail;
						model.contact.TCC = response.data.FM1099ControlInfo.TCC;
						model.horizontal = response.data.FM1099ControlInfo.HorizontalAdjustment;
						model.vertical = response.data.FM1099ControlInfo.VerticalAdjustment;
					}

					if (model.vendors.length > 0) {
						model.vendors = _.sortBy(response.data.Vendors, function (item) {
							return item.VendorName.toLowerCase();
						});

						model.vendorsFiltered = angular.copy(model.vendors);
					}
				} else {
					model.errors.push(response.data.errors);
				}

				return angular.noop;
			}
		}

		function eventRefresh(model) {
			resetModel(model);

			model.busyMessage = BUSY_MESSAGE.Loading;
			model.busyPromise = loadVendors(model).then(() => {
				if (!model.isFinalized && !model.vendorErrors) {
					model.refreshIsReadyForFinalize();
				}
			});
		}

		function formTypeChange(model) {
			model.vendorsFiltered = _.filter(model.vendors, function (item) {
				if (model.selectedFormType === null) {
					return !_.isUndefined(item.FormType1099Id);
				}
				return item.FormType1099Id === model.selectedFormType;
			});
		}

		function resetModel(model) {
			model.vendors = [];
			model.vendorsSelected = [];
			model.print1096 = false;
			model.vendorsCheckAll = false;
			model.horizontal = null;
			model.vertical = null;
			model.validationErrors = [];
			model.createIRS = true;
			model.createState = true;
			model.isFinalized = false;
			model.hasTotals = false;
			model.vendorErrors = false;
			model.isReadyForFinalize = false;
			model.selectedFormType = null;
		}

		function executeRefreshInterval() {
			if ($scope.refresh1099Interval !== null) {
				$interval.cancel($scope.refresh1099Interval);
			}

			$scope.refresh1099Interval = $interval(function () {
				let is1099Page = $location.path().endsWith('fm1099');

				if (is1099Page && $scope.vm.isFinalized === false) {
					$scope.vm.refreshIsReadyForFinalize();
				} else {
					$interval.cancel($scope.refresh1099Interval);
				}
			}, 5000);
		}

		function printErrorReport(model) {
			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			model.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				TaxYear: model.selectedTaxYear,
				Errors: _.filter(model.vendors, function (vendor) {
					return vendor.MissingFederalId === true || vendor.MissingTINCode === true;
				}),
			};

			reportHelper.postReport($scope, '/api/fundreports/fm1099errorreport', report, '1099ErrorReport.pdf');
		}

		function toggleSelection(model, VendorId) {
			if (VendorId === -1) {
				model.vendorsSelected.length = 0;
				if (model.vendorsCheckAll === false) {
					angular.forEach(model.vendorsFiltered, function (vendor) {
						vendor.selected = false;
					});
				} else {
					angular.forEach(model.vendorsFiltered, function (vendor) {
						model.vendorsSelected.push(vendor.VendorId);
						vendor.selected = true;
					});
				}
			} else {
				if (model.vendorsSelected.indexOf(VendorId) > -1) model.vendorsSelected.splice(model.vendorsSelected.indexOf(VendorId), 1);
				else model.vendorsSelected.push(VendorId);
				model.vendorsCheckAll = model.vendorsSelected.length === model.vendors.length;
			}
		}

		function doProcessing(model) {
			if (model.isFinalized !== true) {
				//=====================
				// Validate Adjustments
				//=====================

				let msgList = [];

				if (model.vendors.length === 0) {
					msgList.push('No vendors available for processing.');
				}

				if (model.isLinqProgressActive()) {
					msgList.push('Please clear all "Work in Progress" messages before continuing.');
				}

				if (model.vertical && parseFloat(model.vertical) !== 0) {
					if (model.vertical.trim().length > 0) {
						let vmsg = 'Vertical has an invalid value.  Value can be blank or between -0.15 and 0.25.';

						if (isNaN(parseFloat(model.vertical))) {
							msgList.push(vmsg);
						} else {
							if (parseFloat(model.vertical) < -0.15 || parseFloat(model.vertical) > 0.25) {
								msgList.push(vmsg);
							}
						}
					}
				}

				if (model.horizontal && parseFloat(model.horizonal) !== 0) {
					if (model.horizontal.trim().length > 0) {
						let hmsg = 'Horizontal has an invalid value.  Value can be blank or between -0.15 and 0.25.';

						if (isNaN(parseFloat(model.horizontal))) {
							msgList.push(hmsg);
						} else {
							if (parseFloat(model.horizontal) < -0.15 || parseFloat(model.horizontal) > 0.25) {
								msgList.push(hmsg);
							}
						}
					}
				}

				if (msgList.length !== 0) {
					dialogHelper.openMessageBox("Print 1099's", null, msgList, 'Warning');
					return angular.noop;
				}
			}

			if (model.isFinalized !== true) {
				//===================
				// PROCESS
				//===================

				//====================
				// Contact Information
				//====================

				$uibModal
					.open({
						template: require('@ajs/templates/fund/utilities/fm1099-contact-modal.html'),
						backdrop: 'static',
						keyboard: false,
						scope: $scope,
						controller: [
							'$scope',
							'$uibModalInstance',
							'fm1099Service',
							function ($scope, modalInstance, fm1099Service) {
								angular.extend($scope, {
									cancel: function () {
										modalInstance.close();
									},
									save: function () {
										if (!$scope.contactForm.$valid) return false;

										var paramModel = {
											TaxYear: $scope.vm.selectedTaxYear,
											HorizontalAdjust: $scope.vm.horizontal,
											VerticalAdjust: $scope.vm.vertical,
											ContactName: $scope.vm.contact.Name,
											ContactPhone: $scope.vm.contact.Phone,
											ContactPhoneExt: $scope.vm.contact.PhoneExt,
											ContactEmail: $scope.vm.contact.Email,
											TCC: $scope.vm.contact.TCC,
											CreateIRS: $scope.vm.createIRS,
											CreateState: $scope.vm.createState,
											Include1096: $scope.vm.print1096,
										};

										model.setInfoForFileAndReportCreation(paramModel);
										model.executeRefreshInterval();

										$scope.vm.busyMessage = BUSY_MESSAGE.Processing;
										$scope.vm.busyPromise = fm1099Service.create1099s(paramModel).then(function (response) {
											if (!response.data.isValid) {
												modalInstance.close();
												dialogHelper.openMessageBox("1099's", response.data.errors, null, 'Warning');
											} else {
												modalInstance.close(true);
											}
										});
									},
								});
							},
						],
					})
					.result.then(function (queued) {
						if (queued) {
							dialogHelper.openMessageBox(
								'Create 1099s Requested',
								'Your 1099 creation task is being processed. You will receive a notice when complete.',
								null,
								'Info'
							);
						}
					});
			} else {
				var paramModel = {
					TaxYear: $scope.vm.selectedTaxYear,
					Include1096: $scope.vm.print1096,
				};

				model.setInfoForFileAndReportCreation(paramModel);

				let msgList = [];

				if (isLinqProgressActive()) {
					msgList.push('Please clear all "Work in Progress" messages before continuing.');
				} else if (paramModel.VendorIds.length === 0 && !paramModel.Include1096) {
					msgList.push('Please select one or more vendors to continue.');
				}

				if (msgList.length > 0) {
					dialogHelper.openMessageBox("Reprint 1099's", null, msgList, 'Warning');
					return angular.noop;
				}

				$scope.vm.busyMessage = BUSY_MESSAGE.Processing;
				$scope.vm.busyPromise = fm1099Service.reprint1099s(paramModel);
			}
		}

		function isLinqProgressActive() {
			let hangFireElementCollection = document.getElementsByClassName('linqsockets-progress active');
			return hangFireElementCollection.length > 0;
		}

		function setInfoForFileAndReportCreation(paramModel) {
			paramModel.VendorIds = [];
			paramModel.ReportTypes = [];

			if ($scope.vm.vendorsCheckAll === true) {
				paramModel.VendorIds.push(-1);
			} else {
				paramModel.VendorIds = $scope.vm.vendorsSelected;
			}

			if ($scope.vm.selectedFormType == null || $scope.vm.selectedFormType == formType1099.MISC) {
				paramModel.ReportTypes.push(formType1099.MISC);
			}
			if ($scope.vm.selectedFormType == null || $scope.vm.selectedFormType == formType1099.NEC) {
				paramModel.ReportTypes.push(formType1099.NEC);
			}
		}

		function refreshIsReadyForFinalize() {
			fm1099Service.is1099ReadyForFinalize($scope.vm.selectedTaxYear).then(function (response) {
				$scope.vm.isReadyForFinalize = response.data;
				if (response.data === true) {
					$scope.vm.isReadyForFinalize = response.data;
					$interval.cancel($scope.refresh1099Interval);
				}
			});
		}

		function finalize1099s(model) {
			let msgList = [];

			if (isLinqProgressActive()) {
				msgList.push('Please clear all "Work in Progress" messages before continuing.');
				dialogHelper.openMessageBox("Finalize 1099's", null, msgList, 'Warning');
				return angular.noop;
			}

			msgList.push(`Finalize 1099\'s for tax year ${model.selectedTaxYear.toString()}?`);
			msgList.push(null); // create a line break
			msgList.push('Once you finalize, only 1099 reprints will be available.');
			msgList.push('This cannot be undone!');
			msgList.push(null); // create a line break
			msgList.push('Do you want to continue?');
			msgList.push(null); // create a line break
			dialogHelper.yesnoMessageBox("Finalize 1099's", null, msgList, 'Question', yesFunction, null);

			function yesFunction() {
				model.busyMessage = BUSY_MESSAGE.Processing;
				model.busyPromise = fm1099Service.finalize1099s($scope.vm.selectedTaxYear).then(finishFinalize);

				function finishFinalize(response) {
					if (response.data.isValid === false) {
						dialogHelper.openMessageBox("Finalize 1099's", response.data.errors, null, 'Warning');
						return false;
					}

					model.busyMessage = BUSY_MESSAGE.Loading;
					model.busyPromise = $q.all([$scope.vm.loadForm($scope.vm)]);
				}
			}
		}

		return angular.extend(model, {
			loadForm: _.partial(loadForm, model),
			loadVendors: _.partial(loadVendors, model),
			eventRefresh: _.partial(eventRefresh, model),
			formTypeChange: _.partial(formTypeChange, model),
			resetModel: _.partial(resetModel, model),
			printErrorReport: _.partial(printErrorReport, model),
			toggleSelection: _.partial(toggleSelection, model),
			process: _.partial(doProcessing, model),
			setInfoForFileAndReportCreation: setInfoForFileAndReportCreation,
			executeRefreshInterval: executeRefreshInterval,
			refreshIsReadyForFinalize: refreshIsReadyForFinalize,
			isLinqProgressActive: isLinqProgressActive,
			finalize1099s: _.partial(finalize1099s, model),
		});
	}
}
